import { gql } from '@apollo/client'

import { SequenceTemplateFragment } from '../fragments'

export const MUTATION_CREATE_SEQUENCE_TEMPLATE = gql`
  mutation createSequenceTemplate($input: SequenceTemplateCreateInput!) {
    createSequenceTemplate(input: $input) {
      ...SequenceTemplateFragment
    }
  }
  ${SequenceTemplateFragment}
`

export const MUTATION_UPDATE_SEQUENCE_TEMPLATE = gql`
  mutation updateSequenceTemplate($input: SequenceTemplateUpdateInput!) {
    updateSequenceTemplate(input: $input) {
      ...SequenceTemplateFragment
    }
  }
  ${SequenceTemplateFragment}
`

export const MUTATION_DELETE_SEQUENCE_TEMPLATE = gql`
  mutation deleteSequenceTemplate($id: ID!) {
    deleteSequenceTemplate(id: $id)
  }
`

export const MUTATION_SORT_SEQUENCE_TEMPLATES = gql`
  mutation sortSequenceTemplates($input: SequenceTemplatesSortInput!) {
    sortSequenceTemplates(input: $input) {
      ...SequenceTemplateFragment
    }
  }
  ${SequenceTemplateFragment}
`
